import * as ACTION_TYPES from '@actions/action_types'
import { usePost, useUpdate } from '@utils/reactQuery'
import type { UseQueryOptions, UseQueryResult } from 'react-query'
import { useAppQuery } from '../services/useAppQuery'

export const get_current_shop = (reactQueryOptions: UseQueryOptions) => {
  return useAppQuery({
    key: ['current-shop'],
    url: ACTION_TYPES.SHOP_SHOW_PATH,
    reactQueryOptions,
  })
}

export const check_verify_email = (reactQueryOptions: UseQueryOptions) => {
  return useAppQuery({
    key: ['check-verify-email'],
    url: `${ACTION_TYPES.SHOPS_PATH}/check_email_verify`,
    reactQueryOptions,
  })
}

export const whoami = (reactQueryOptions: UseQueryOptions) : UseQueryResult<A> => {
  return useAppQuery({
    key: ['whoami'],
    url: `${ACTION_TYPES.SHOPS_PATH}/whoami`,
    reactQueryOptions,
  }) as UseQueryResult<A>
}

export const update_shop = <T, S>(
  params?: object,
  updater?: (oldData: T, newData: S) => T,
) => {
  return useUpdate(`${ACTION_TYPES.SHOPS_PATH}`, params, updater)
}

export const verify_email = <T, S>(
  params?: object,
  updater?: (oldData: T, newData: S) => T,
) => {
  return usePost(`${ACTION_TYPES.SHOPS_PATH}/email_verify`, params, updater)
}

/** Client cache for Money currency list — BE caches 1h; FE keeps fresh 5m. */
const CURRENCY_LIST_STALE_MS = 5 * 60 * 1000
const CURRENCY_LIST_CACHE_MS = 30 * 60 * 1000

export const load_currency = (reactQueryOptions: UseQueryOptions = {}) => {
  return useAppQuery({
    key: ['load_currency'],
    url: `${ACTION_TYPES.SHOPS_PATH}/get_currencies`,
    reactQueryOptions: {
      staleTime: CURRENCY_LIST_STALE_MS,
      cacheTime: CURRENCY_LIST_CACHE_MS,
      refetchOnWindowFocus: false,
      ...reactQueryOptions,
    },
  })
}
export const fork_on_install = <T, S>(
  params?: object,
  updater?: (oldData: T, newData: S) => T,
) => {
  return usePost(`${ACTION_TYPES.SHOPS_PATH}/fork_on_install`, params, updater)
}

export const shop_currencies = (reactQueryOptions: UseQueryOptions) => {
  return useAppQuery({
    key: ['shop_currencies'],
    url: `${ACTION_TYPES.SHOPS_PATH}/shop_currencies`,
    reactQueryOptions,
  })
}

export const smtp_test = (params?: object) => {
  return usePost(`${ACTION_TYPES.SHOPS_PATH}/smtp_test`, params, undefined)
}

export const upload_logo = <T, S>(
  params?: object,
  updater?: (oldData: T, newData: S) => T,
) => {
  return usePost(`${ACTION_TYPES.SHOPS_PATH}/upload_logo`, params, updater)
}

export const get_activities = (reactQueryOptions: UseQueryOptions) => {
  return useAppQuery({
    key: ['get_activities'],
    url: `${ACTION_TYPES.SHOPS_PATH}/activities`,
    reactQueryOptions,
  })
}
